import {environment} from '../../../environments/environment';

const awsConfig = {
  Auth: {
    region: environment.aws.region,
    userPoolId: environment.aws.userPoolId,
    userPoolWebClientId: environment.aws.userPoolWebClientId,
  },
};

export default awsConfig;
